enum CardType {
  SideKickCanada = 'sidekickCanada',
  SideKickInternational = 'SideKickInternational',
}

export default CardType
